module.exports = __webpack_public_path__ + "static/media/t-i-fitouts.da2b2912.png";